// utilities
import api from '@/utilities/api'

export const getGatePasses = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/passes/gate',
    payload,
    success (response) {
      commit('setGatePasses', response.data)
    }
  })
}
export const updateGatePassAssign = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'private/passes/gate/assign',
    payload,
    success (response) {
      dispatch('itineraries/getItineraries', null, { root: true })
      dispatch('parkingBookings/getParkingBookings', null, { root: true })
      dispatch('getGatePasses')
    }
  })
}
export const updateGatePassUnassign = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/passes/gate/assign',
    payload,
    success (response) {
      dispatch('itineraries/getItineraries', null, { root: true })
      dispatch('parkingBookings/getParkingBookings', null, { root: true })
      dispatch('getGatePasses')
    }
  })
}
export const updateGatePassRevoke = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'private/passes/gate/' + payload.gatePassID + '/revoke',
    payload,
    success (response) {
      dispatch('getGatePasses')
    }
  })
}
export const updateGatePassRenew = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'private/passes/gate/' + payload.gatePassID + '/renew',
    payload,
    success (response) {
      dispatch('getGatePasses')
    }
  })
}
export const deleteGatePasses = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/passes/gate',
    payload
  })
}
export const getGatePass = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/passes/gate/' + payload.gatePassID,
    payload,
    success (response) {
      commit('setGatePass', response.data[0])
    }
  })
}
